import React from 'react';
import ErrorBoundary, { ErrorBoundaryProps } from './ErrorBoundary';

function withErrorBoundary<T>(
  WrappedComponent: React.ComponentType<T>,
  errorBoundaryOptions: ErrorBoundaryProps = {},
): React.FC<T> {

  const componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || 'unknown';

  const Wrapped: React.FC<T> = (props: T) => (
    <ErrorBoundary {...errorBoundaryOptions}>
      <WrappedComponent {...props} />
    </ErrorBoundary>
  );

  Wrapped.displayName = `errorBoundary(${componentDisplayName})`;

  return Wrapped;
}

export default withErrorBoundary;
